import yearData from "../utils/year-data";

export default class dateService {
  static async getYears() {
    try {
      let years = yearData;
      return years;
    } catch (error) {
      return {
        status: "error",
        message: "Ocurrio un error al obtener los años",
      };
    }
  }
}